module.exports = __webpack_public_path__ + "img/foodwaste.93c887a5.svg";